module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"yes":"Yes","follow":"Follow","no_follow":"No Follow"},"fr":{"yes":"Oui","follow":"Follow","no_follow":"No Follow"},"de":{"yes":"Ja","follow":"Folgen","no_follow":"Kein Folgen"}}')
  delete Component.options._Ctor
}
